import React from 'react'
import { useTranslation } from 'react-i18next'

function PortFolioCards(props) {
    const [t] = useTranslation("global");
    return (
        <div className='Pcard' style={{backgroundImage:`url(${props.image})`}}>
            <div className='Pcard-content' style={{width:'100%'}}>
                <h1 className='Pcard-title'>{props.title} </h1>
                <p className='Pcard-body'>{t(props.paragraph)}</p>
                <a href={props.link} className='Pcard-link'>{t("LearnMore")}</a>
            </div>
        </div>
    )
}

export default PortFolioCards
